export default {
  radiusBlockUi: '2px',
  borderWidth: '1px',
  borderWidthFocus: '1.5px',
  borderWidthTab: '4px',
  spinnerSize: '18px'
};
//# sourceMappingURL=config-values.js.map